module.exports = __webpack_public_path__ + "static/media/11NEPAD2.7c0a2c85.jpg";